// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310913/js/" + chunkId + "." + {"44":"3b810b2a","225":"a80a4666","481":"0e5856f3","486":"4eac7828","770":"69966a46"}[chunkId] + ".0.5248053666841415.chunk.js";
};